import { useEffect } from 'react';
import { useAction } from 'hooks';
import Account from 'modules/Account';
export const usePatientProfileEffects = ()=>{
    const fetchPayers = useAction(Account.actions.fetchPayers);
    const fetchCountrySettings = useAction(Account.actions.fetchCountrySettings);
    useEffect(()=>{
        fetchPayers();
        fetchCountrySettings();
    }, []);
};
